<template>
  <section
    id="video-section"
    class="video-section"
  >
    <div class="container">
      <div class="title-wrapper">
        <p class="label">Tech-Enabled, Human-Powered</p>
        <h3 class="title">“{{ title }}”</h3>
        <p class="name">Catalina Istrate</p>
        <span class="role">VP Tech Performance Enablement</span>
      </div>

      <div
        class="preview-video-wrapper"
        @click="showVideoModal = true"
      >
        <NuxtImg
          src="/images/home-page/video-section/catalina.png"
          alt="Catalina Istrate - VP Tech Performance Enablement"
          class="video-thumbnail"
          width="800"
          lazy
        />
        <PlayIcon class="play-button" />
      </div>

      <VideoPopup
        v-if="showVideoModal"
        :video="mainVideo"
        autoplay
        @close="showVideoModal = false"
      />
    </div>
  </section>
</template>

<script>
import PlayIcon from './assets/PlayIcon.vue';
import VideoPopup from '~/components/Common/Video/VideoPopup/VideoPopup.vue';

export default {
  components: {
    VideoPopup,
    PlayIcon,
  },
  data() {
    return {
      showVideoModal: false,
      mainVideo:
        'https://player.vimeo.com/video/1094946652?h=c3191287e3&fullscreen=1',
      poster: '',
      title:
        'At Proxify, we do not have short-term projects, we have career paths with clients seeking to integrate our tech experts as an essential part of their team',
    };
  },
};
</script>

<style lang="scss" scoped>
@import './VideoSection.scss';
</style>
